import { Actions, Header, Image, Link, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { noop } from '../../../lib/utils';
import styles from './ThankYou.module.css';

const cx = classnames.bind(styles);

function ThankYouContent({ creditsAwarded, messageType }) {
  const { t } = useTranslation(['price', 'review', 'miscellaneous']);
  if (messageType === 'review') {
    return (
      <Fragment>
        <Header as="h3">
          {t('thankYouHeader', { ns: 'review' })}
        </Header>
        <Text as="p">
          {t('thankYouMessage', { ns: 'review' })}
        </Text>
        <br />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Header as="h3">
        {t('thankYouSubmissionHeader', { ns: 'price' })}
      </Header>
      <div className={cx('successImageContainer')}>
        <Image
          alt={t('icons.submissionTrophy', { ns: 'miscellaneous' })}
          src="https://static.gasbuddy.com/web/consumer/submission-trophy.svg"
        />
      </div>
      {creditsAwarded > 0 && (
        <Text as="p" data-testid="creditsAwarded">
          <Trans i18nKey="price:thankYouSubmissionCreditsAwarded" credits={creditsAwarded}>
            You have earned <Text as="strong">{{ credits: creditsAwarded }} credits</Text> for those prices.
          </Trans>
        </Text>
      )}
      <Text as="p">
        {t('thankYouPrizeDrawText', { ns: 'price' })}
      </Text>
    </Fragment>
  );
}

ThankYouContent.propTypes = {
  creditsAwarded: PropTypes.number,
  messageType: PropTypes.string.isRequired,
};

ThankYouContent.defaultProps = {
  creditsAwarded: 0,
};

export default function ThankYou({
  creditsAwarded,
  messageType,
  onDone,
}) {
  const { t } = useTranslation('miscellaneous');
  return (
    <Fragment>
      <ThankYouContent creditsAwarded={creditsAwarded} messageType={messageType} />
      <br />
      <Actions>
        <Actions.Button
          primary
          wide
          onClick={onDone}
          desktop={6}
          data-testid="doneButton"
        >
          {t('actions.done', { ns: 'miscellaneous' })}
        </Actions.Button>
        {messageType === 'price' && (
          <Actions.Action desktop={6}>
            <Link to="/contest/gas-card-give-away" uppercase>
              {t('navigation.enterToWin', { ns: 'miscellaneous' })}
            </Link>
          </Actions.Action>
        )}
      </Actions>
    </Fragment>
  );
}

ThankYou.propTypes = {
  creditsAwarded: PropTypes.number,
  messageType: PropTypes.oneOf(['review', 'price']).isRequired,
  onDone: PropTypes.func,
};

ThankYou.defaultProps = {
  creditsAwarded: 0,
  onDone: noop,
};
